import { Button } from "@heroui/react"
import PropTypes from "prop-types"

const Footer = ({ 
  currentStep, 
  handlePrevious = () => {}, 
  handleNext = () => {}, 
  isNextButtonDisabled = false,
  isPreviousButtonDisabled = false,
  isSubmitting = false, 
  nextCaption,
  previousCaption, 
  totalSteps 
}) => {
  const isFinalStep = currentStep === totalSteps
  
  return (
    <div className="flex items-center justify-between mt-2 mb-2">
      <Button className="mt-4" color="default" size="lg" tabIndex="-1" onPress={(e) => handlePrevious()} isDisabled={isPreviousButtonDisabled}>
        {currentStep === 1 ? previousCaption : `Previous Step: ${previousCaption}`}
      </Button>

      <Button className="mt-4" color="secondary" size="lg" onPress={() => handleNext()} isLoading={isSubmitting} isDisabled={isNextButtonDisabled}>
        {!isFinalStep ? <span>Next Step: {nextCaption}</span> : <span>{nextCaption}</span>}
      </Button>
    </div>
  )
}

Footer.propTypes = {
  currentStep: PropTypes.number.isRequired,
  previousCaption: PropTypes.string.isRequired,
  nextCaption: PropTypes.string.isRequired,
  handlePrevious: PropTypes.func,
  handleNext: PropTypes.func,
  isNextButtonDisabled: PropTypes.bool,
  isPreviousButtonDisabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  totalSteps: PropTypes.number.isRequired
}

export default Footer

